import React from 'react';
import lozad from 'lozad';

//https://reactjs.org/docs/lists-and-keys.html#extracting-components-with-keys
class ProductItem extends React.Component {

	constructor() {
		super();
		this.loadAssets = lozad('.lazy');
	}

	componentDidMount() {
		this.loadAssets.observe();
	}	

	//https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
	desc() {
        let desc = this.props.desc;
        return { __html: desc };			
	}

	render() {
		return (
			<li className="grid__item item--product">
				<a href={this.props.url} title={this.props.title}>
					<div className="product__meta">
						{!this.props.parent && this.props.type == 'product' &&
							<figure className="product__ico">
								<img className="lazy" data-src={`${wp_core.theme_url}/assets/img/ico/products/${this.props.id}.svg`} alt={this.props.title} />	
							</figure>
						}
						<h3 className="product__title">{this.props.title}</h3>
						<p className="product__desc" dangerouslySetInnerHTML={this.desc()} />			
					</div>
					<button className="button button--purple button--expand">
						<span className="button__label">{wp_core.l18n.cta}</span>
						<span className="button__ico"></span>
					</button>
				</a>
			</li>
		);
	}
}

export default ProductItem;